import {apiClient} from '../client'
import tcWrap from '../../utilities/generic-helpers/tcWrap'

export const fetchConfiguration = () => tcWrap(async () => {
  const {configuration} = await apiClient.get('configurations/generic', {retryWithClientCredentials: true})
  return configuration
})
